<template>
  <div>
    <b-modal
      ref="modal-setting-travel-route"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="">
        <ValidationObserver ref="ref-validation-route">
          <b-row>
            <!-- Origin -->
            <b-col sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="origin_id"
              >
                <b-form-group
                  :label="$t('Origin')"
                  label-for="origin_id"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="origin_id"
                    v-model="form.origin_id"
                    :options="originRoutes"
                    append-to-body
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.location_id"
                    label="location"
                    @search="searchOrigins"
                    @input="selectRoute()"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Origin -->
            <b-col sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="destination_id"
              >
                <b-form-group
                  :label="$t('Destination')"
                  label-for="destination_id"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="destination_id"
                    v-model="form.destination_id"
                    :options="destinationRoutes"
                    append-to-body
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.location_id"
                    label="location"
                    @search="searchDestinations"
                    @input="selectRoute()"
                  />
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Toll group -->
            <b-col sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="toll_group"
              >
                <b-form-group
                  :label="$t('Toll group')"
                  label-for="toll_group"
                  :state="errors[0] ? false : null"
                >
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    v-model="form.toll_group_id"
                    :options="tolls"
                    append-to-body
                    :calculate-position="positionDropdown"
                    :placeholder="`${$t('Search')}...`"
                    :reduce="(l) => l.toll_group_id"
                    label="group_name"
                    :disabled="form.origin_id == null && form.destination_id == null"
                    @input="tollGroupSelector()"
                  />
                </b-form-group>
              </ValidationProvider>                
            </b-col>

            <b-col sm="6" class="d-flex align-items-center">
              <div>
                <b-button
                variant="primary"
                size="sm"
                @click="showTollGroupModal = true"
                :disabled="form.destination_id == null || form.origin_id == null"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="cursor-pointer"                    
                    />
                    {{ $t('Create toll group')}}
                </b-button>
              </div>
            </b-col>

            <b-col cols="12">
              <div v-if="tollGroupSelected.length > 0">
                <div>
                  <b-card no-body>
                    <b-card-text>
                      <b-table :items="tollGroupSelected" :fields="fields" sticky-header>
                        <template #cell(toll_name)="data">
                          <tabler-icon
                          icon="TicketIcon"
                          class="text-warning"
                          />
                          {{ data.item.toll_name }}
                        </template>
                        <template #cell(toll_amount)="data">
                          S/ {{ parseFloat(data.item.toll_amount).toFixed(2) }}
                        </template>
                        <template #cell(toll_type)="data">
                          <div :class="data.item.toll_type == 'CASH' ? 'text-success' : 'text-warning'">
                            {{ $t(data.item.toll_type) }}
                          </div>
                        </template>
                      </b-table>
                    </b-card-text>
                  </b-card>
                </div>                
              </div>
            </b-col>

            <b-col cols="12" v-if="tollGroupSelected.length != 0">
            <div class="d-flex justify-content-end">
              <div class=" px-2">
                <strong>{{ $t("Quantity") }}: </strong> {{ quantityTolls }}
              </div>
              <div>
                <strong>Total: </strong> S/ {{ totalToll }}
              </div>
            </div>
          </b-col>
          </b-row>
        </ValidationObserver>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="routeId == null"
            @click="registerRoute"
            variant="outline-success"
            >{{ $t("REGISTER") }}</b-button
          >
          <b-button
            v-if="routeId != null"
            @click="updateRoute"
            variant="outline-warning"
            >{{ $t("UPDATE") }}</b-button
          >
        </div>
      </template>
    </b-modal>
    <toll-group-modal
    v-if="showTollGroupModal"
    :tollList="tollsSelected"
    :originId="form.origin_id"
    :destinationId="form.destination_id"
    @reloadGroups="selectRoute()"
    @hideModal="closeModal()"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import TravelRoutesService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import TollGroupModal from "@/views/settings/views/travel-routes/modals/CreateTollGroup.vue"

export default {
  components: {
    TollGroupModal,
  },
  mixins: [modalMixin],
  props: {
    routeId: {
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        origin_id: null,
        destination_id: null,
        tolls: 0,
        toll_group_id: null,
      },
      originRoutes: [],
      destinationRoutes: [],
      finishedLoading: false,
      tolls: [],
      showTollGroupModal: false,
      tollList: [],
      tollGroupSelected: [],
      tollsSelected: [],
      fields: [
          { key: 'toll_name', label: app.$i18n.t('Name') },
          { key: 'toll_amount', label: app.$i18n.t('Amount') },
          { key: 'toll_type', label: app.$i18n.t('Type') },
        ]
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      if (this.routeId == null) return "NEW ROUTE";
      return "EDIT ROUTE";
    },
    totalToll(){
      let totalAmount = 0;
      this.tollGroupSelected.forEach(item => {
        totalAmount += parseFloat(item.toll_amount)
      })
      return totalAmount.toFixed(2);
    },
    quantityTolls(){
      return this.tollGroupSelected.length
    }
  },
  watch: {},
  mounted() {
    this.toggleModal("modal-setting-travel-route");
  },
  async created() {
    try {
      this.form.id = this.routeId;
      this.finishedLoading = false;
      this.addPreloader();
      await Promise.all([this.getDataRouteById()]);
    } catch (error) {
      console.log(error);
      this.showToastError(error?.response?.data?.message);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  methods: {
    async selectRoute(){
      this.tollGroupSelected = [];
      this.form.toll_group_id = null;
      if(this.form.destination_id != null && this.form.origin_id != null){
        const params = {
          "origin_id": this.form.origin_id,
          "destination_id": this.form.destination_id
        }
        const { data } = await TravelRoutesService.getTollsForRoute(params);
        this.tolls = data
        this.tollsSelected = JSON.parse(this.tolls[0].toll)
      }
    },
    tollGroupSelector(){
      const aux = this.tolls.find(toll => toll.toll_group_id == this.form.toll_group_id)
      this.tollGroupSelected = JSON.parse(aux.toll);
    },
    searchOrigins: _.debounce(async function (search) {
      if (search.length < 3 || search == undefined) return;
      const { data } = await TravelRoutesService.getLocationsForSelect({
        text: search,
      });
      this.originRoutes = data;
    }),

    searchDestinations: _.debounce(async function (search) {
      if (search.length < 3 || search == undefined) return;
      const { data } = await TravelRoutesService.getLocationsForSelect({
        text: search,
      });
      this.destinationRoutes = data;
    }),

    async getDataRouteById() {
      if (this.routeId == null) return;
      try {
        const { data } = await TravelRoutesService.getDataRouteById({
          route_id: this.form.id,
        });

        this.form.origin_id = data[0].origin_id;
        this.form.destination_id = data[0].destination_id;
        await this.selectRoute();
        this.form.toll_group_id = data[0].toll_group_id;
        this.tollGroupSelector();
        this.form.tolls = data[0].quantity_toll_stations;
        this.searchOrigins(data[0].origin);
        this.searchDestinations(data[0].destination);
      } catch (error) {
        throw error;
      }
    },

    async registerRoute() {
      const result = await this.$refs["ref-validation-route"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          origin_id: this.form.origin_id,
          destination_id: this.form.destination_id,
          tolls: this.form.tolls,
          user_id: this.currentUser.id,
          toll_group_id: this.form.toll_group_id
        };
        const { data } = await TravelRoutesService.registerRoute(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async updateRoute() {
      const result = await this.$refs["ref-validation-route"].validate();
      if (!result) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          route_id: this.form.id,
          origin_id: this.form.origin_id,
          destination_id: this.form.destination_id,
          tolls: this.form.tolls,
          user_id: this.currentUser.id,
          toll_group_id: this.form.toll_group_id
        };

        const { data } = await TravelRoutesService.updateRoute(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.maxHeight = "20rem";
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },
    closeModal(){
      this.showTollGroupModal = false;
    }
  },
};
</script>

<style>
</style>